export enum ScoreClassificationLabel {
  Pass = 'Pass',
  Marginal = 'Marginal',
  Fail = 'Fail',
  Nodata = 'Nodata',
  Error = 'Error',
}
